module.exports = __webpack_public_path__ + "media/images/games/35gender/cars-bf4daf18a8015b4ebd5dde1ade279054.png";